import saveFileMetaToFirestore from "./firestoreService"

export default saveFileMetaToFirestore
